import { Check } from 'lucide-react';
import { CATEGORIES, TEMPLATES } from '../../constants/templates';

export default function TemplatePicker({
  activeCategory,
  setActiveCategory,
  selectedTemplate,
  setSelectedTemplate,
  accentOverrides,
}) {
  const pickCategory = (catId) => {
    setActiveCategory(catId);
    const cat = CATEGORIES.find(c => c.id === catId);
    if (cat && !cat.variants.includes(selectedTemplate)) {
      setSelectedTemplate(cat.variants[0]);
    }
  };

  return (
    <>
      <div className="flex gap-1 overflow-x-auto preview-scroll pb-px">
        {CATEGORIES.map(cat => (
          <button
            key={cat.id}
            onClick={() => pickCategory(cat.id)}
            className={`tool-body px-3 py-2 text-xs uppercase tracking-[0.15em] whitespace-nowrap border-b-2 transition-colors ${
              activeCategory === cat.id
                ? 'border-stone-900 text-stone-900 font-medium'
                : 'border-transparent text-stone-500 hover:text-stone-800'
            }`}
          >
            {cat.label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-2 py-3">
        {CATEGORIES.find(c => c.id === activeCategory).variants.map(tplId => {
          const tpl = TEMPLATES[tplId];
          const active = tplId === selectedTemplate;
          const tplAccent = (accentOverrides[tplId]?.accent) || tpl.accent;
          return (
            <button
              key={tplId}
              onClick={() => setSelectedTemplate(tplId)}
              className={`tool-body text-left px-3.5 py-2 rounded text-xs border transition-all ${
                active
                  ? 'border-stone-900 bg-stone-900 text-white shadow-sm'
                  : 'border-stone-300 bg-white text-stone-700 hover:border-stone-500'
              }`}
            >
              <div className="flex items-center gap-2">
                <span
                  className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                  style={{ background: tplAccent }}
                />
                <span className="font-medium">{tpl.label}</span>
                {active && <Check className="w-3 h-3 ml-1" />}
              </div>
              <div className={`text-[10.5px] mt-0.5 leading-tight ${active ? 'text-stone-300' : 'text-stone-500'}`}>
                {tpl.blurb}
              </div>
            </button>
          );
        })}
      </div>
    </>
  );
}
